module.exports = __webpack_public_path__ + "static/img/anli5.d9e0cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli5.jpg
// module id = dAkO
// module chunks = 1